// extracted by mini-css-extract-plugin
module.exports = {"dashboardWrapper":"style__dashboardWrapper__Guoqh"};